import { atom } from 'recoil';

export const fps = atom({
  key: 'fps',
  default: 60,
});
